export const SET_LAYER_ARTIFACTS = 'SET_LAYER_ARTIFACTS';

export const setLayerArtifactsAction = ({ onOverlayClick }) => ({
    type: SET_LAYER_ARTIFACTS,
    payload: {
        onOverlayClick
    }
});
